module.exports = __webpack_public_path__ + "img/item9.b9c16339.png";